import {IDesignInfo} from '@mintdata-wsp/common/state/DataState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DesignsListItem} from '@mintdata-wsp/wsp/ui/views/workspace/home/designs/DesignsListItem';
import {DesignsNotFound} from '@mintdata-wsp/wsp/ui/views/workspace/home/designs/DesignsNotFound';
import {DesignsFilters, DesignsFilterType} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsFilters';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DesignsList.less');
const cx = classnames.bind(styles);

interface Props
{
    filterType:DesignsFilterType;
    designs:IDesignInfo[];
    newDesign?:boolean;
    viewAsApplication?:boolean;
    goToSpaceMenu?:boolean;
    highlightSearchTerm?:boolean;
}

@observer
export class DesignsList extends React.Component<Props, any>
{
    private _onClickNewDesign = async () =>
    {
        await controllers.data.projects.syncAllProjects();

        controllers.ui.dialogs.showDialog(Dialogs.AddDesign, false);
    };

    private _renderNewDesign = ():JSX.Element | null =>
    {
        const {newDesign} = this.props;

        if( !newDesign ) return null;

        return (
            <div
                key={'newDesign'}
                className={cx(styles.design, styles.newDesign)}
                onClick={this._onClickNewDesign}
            >
                <div className={styles.bgImgWrapper}>
                    <img className={styles.bgImg} src="/assets/images/home/new_design_bg.svg" alt="" />
                </div>
                <div className={styles.iconPlus} />
                <div className={styles.newDesignText}>
                    New Design
                </div>
            </div>
        );
    };

    private _renderSpacers = ():JSX.Element[] =>
    {
        return [...Array.from(Array(10).keys())].map((index:number) =>
        {
            return (
                <div
                    key={'spacer' + index}
                    className={cx(styles.design, styles.spaceDesign)}
                />
            );
        });
    };

    private _renderDesignsList = ():JSX.Element[] =>
    {
        const {designs, filterType, viewAsApplication, goToSpaceMenu, highlightSearchTerm} = this.props;

        // const designsFilter = controllers.ui.mainPage.getDesignsFilter(filterType);

        // const viewAsApplication:boolean = designsFilter === DesignsFilter.Published;

        return designs.map((design:IDesignInfo) =>
        {
            return (
                <DesignsListItem
                    key={`${design.id} ${(design.appVersion && design.appVersion.id)}`}
                    design={design}
                    viewAsApplication={viewAsApplication}
                    goToSpaceMenu={goToSpaceMenu}
                    filterType={filterType}
                    highlightSearchTerm={highlightSearchTerm}
                />
            );
        });
    };

    private _renderDesigns = ():JSX.Element[] =>
    {
        return [
            this._renderNewDesign(),
            ...this._renderDesignsList(),
            ...this._renderSpacers(),
        ];
    };

    render():JSX.Element
    {
        const {filterType, designs} = this.props;

        const hasDesigns:boolean = designs && designs.length != 0;

        const showFilters:boolean =
            filterType !== DesignsFilterType.HomeDesigns &&
            filterType !== DesignsFilterType.HomeApplications;

        return (
            <div className={styles.designsWrapper}>
                {
                    showFilters &&
                    <DesignsFilters filterType={filterType} />
                }
                <div className={cx(styles.designs, {oneLine: !showFilters && hasDesigns})}>
                    {
                        !hasDesigns &&
                        <DesignsNotFound filterType={filterType} />
                    }
                    {
                        hasDesigns &&
                        this._renderDesigns()
                    }
                </div>
            </div>
        );
    }
}
